import axios from "axios";

// Created for use in server-side environments like Next.js middleware where Axios is not supported.
export const getListingSearchDataWithFetch = async (data, type = "listing") => {
  const res = await fetch(`${process.env.EJ_APPS_SEARCH_API}/search/v2/${type}${data}`, {
    cache: "no-cache",
  });
  return res.json();
};

export const getLandingPageDataWithFetch = async (url, page = 0) => {
  const endpoint = `${process.env.EJ_APPS_SEARCH_API}/search/v1/listing/landing-page`;

  const res = await fetch(endpoint, {
    method: "POST",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      url,
      page,
    }),
  });

  return res.json();
};

export const getListingSearchData = async (data, type = "listing") => {
  const url = `${process.env.EJ_APPS_SEARCH_API}/search/v2/${type}${data}`;
  return axios.get(url).then((response) => response.data);
};

export const getLandingPageData = (url, page = 0) => {
  const endpoint = `${process.env.EJ_APPS_SEARCH_API}/search/v1/listing/landing-page`;
  return axios
    .post(
      endpoint,
      { url, page },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);
};

export const getProjectListingSearchData = (data) => {
  const url = `${window.env.EJ_APPS_SEARCH_API}/search/v2/project${data}`;
  return axios.get(url).then((response) => response.data);
};

export const getQuickFilterSuggest = (path) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiUrl}/search/v1/quick-filter/suggest/url${path}`;
  return axios.get(url).then((response) => response.data);
};

export const getRegionPrice = (searchUrl) => {
  const url = `${window.env.EJ_APPS_SEARCH_API}/search/v1/region-price${searchUrl}`;
  return axios.get(url).then((response) => response.data);
};

// Created for use in server-side environments like Next.js middleware where Axios is not supported.
export const getListingDetailDataWithFetch = async (data) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const res = await fetch(`${apiUrl}/search/v1/listing/detail/${data}`, {
    cache: "no-cache",
  });

  return res.json();
};

export const getListingDetailData = async (data) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiUrl}/search/v1/listing/detail/${data}`;

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const getNearbyPOIs = ({ id, categories, limit }) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/listing/${id}/nearby-poi?category=${categories.join(
    ","
  )}&limit=${limit}`;
  return axios.get(url).then((response) => response.data);
};

export const getSimilarListings = ({ listingId, limit = 20, accountOnly = false }) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiUrl}/search/v1/listing/similar/${listingId}?accountOnly=${accountOnly}&limit=${limit}`;
  return axios.get(url).then((response) => response.data);
};

export const getListingCount = (data, type = "listing") => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiUrl}/search/v1/${type}/count${data}`;
  return axios.get(url).then((response) => response.data);
};

export const getListings = ({ url, params = {} }) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const endpoint = `${apiUrl}/search/v1/selection${url}`;
  return axios
    .post(endpoint, params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);
};

export const getProjectDetailData = async (data) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const response = await axios.get(`${apiUrl}/search/v1/project/detail/${data}`, {
    headers: {
      "Cache-Control": "no-cache",
    },
  });

  return response.data;
};
